import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import {
    fetchCartAsync,
    setCartState,
    putCartAsync,
    fetchCart,
    putCart,
} from '../../actions/app/cart.actions'
import { getFetchCartApiUrl, getPutCartApiUrl } from '../../../constants/apiUrls'
import configuredCarlineIdSelector from '../../selectors/carlines/configuredCarlineIdSelector'
import { fetchModels } from '../../actions/app/models.actions'
import { fetchEquipmentGroups } from '../../actions/app/equipmentGroups.actions'
import { ApiRequest } from '../../apiRequest'
import {fetchVwnRecommendationsForModel, resetVwnRecommendationsForModelData} from '../../actions/app/vwnRecommendation.actions'
import {fetchAiRecommendationsForModel} from '../../actions/app/aiRecommendation.actions'
import configurationIsBuildableSelector from '../../selectors/configuration/configurationIsBuildableSelector'
import modelHasRecommendationsSelector from '../../selectors/recommendations/modelHasRecommendationsSelector'
import isAirecEnabledSelector from '../../selectors/feature-scope/isAirecEnabledSelector'

const cartMiddleware = (apiRequest: ApiRequest): Middleware => (store) => (next) => (action) => {
    next(action)
    const { dispatch, getState } = store

    if (isActionOf(fetchCart, action)) {
        apiRequest({
            options: {
                url: getFetchCartApiUrl(),
                method: 'GET',
            },
            asyncActions: fetchCartAsync,
            causedBy: action,
        }, dispatch)
    }

    if (isActionOf(fetchCartAsync.success, action)) {
        const cart = action.payload
        const state = getState()
        const carIsBuildable = configurationIsBuildableSelector(state)
        const modelHasVwnAiRecommendations = modelHasRecommendationsSelector(state)
        const isAirecEnabled = isAirecEnabledSelector(state)

        dispatch(setCartState(cart))

        if (isAirecEnabled) {
            dispatch(fetchAiRecommendationsForModel())
        } else if (carIsBuildable && modelHasVwnAiRecommendations) {
            dispatch(fetchVwnRecommendationsForModel())
        } else {
            dispatch(resetVwnRecommendationsForModelData())
        }
    }

    if (isActionOf(putCart, action)) {
        const priceViewFlag = action.payload

        apiRequest({
            options: {
                url: getPutCartApiUrl(priceViewFlag),
                method: 'PUT',
            },
            asyncActions: putCartAsync,
            causedBy: action,
        }, dispatch)
    }

    if (isActionOf(putCartAsync.success, action)) {
        const cart = action.payload
        const carlineId = configuredCarlineIdSelector(getState())
        const state = getState()
        const carIsBuildable = configurationIsBuildableSelector(state)
        const modelHasVwnAiRecommendations = modelHasRecommendationsSelector(state)
        const isAirecEnabled = isAirecEnabledSelector(state)

        dispatch(setCartState(cart))
        dispatch(fetchModels(carlineId))
        dispatch(fetchEquipmentGroups())

        if (isAirecEnabled) {
            dispatch(fetchAiRecommendationsForModel())
        } else if (carIsBuildable && modelHasVwnAiRecommendations) {
            dispatch(fetchVwnRecommendationsForModel())
        } else {
            dispatch(resetVwnRecommendationsForModelData())
        }
    }
}

export default cartMiddleware
